module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_6000.2c8d0149.png";